import '../Profile.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";

import { getCompanyById } from 'containers/Accounts/store/actions';
import { clearMessage, setMessage } from 'containers/Messaging/store/actions';

import A from 'components/A';
import Avatar from 'components/Avatar';
import Button from 'components/Button';
import CircleIcon from 'components/CircleIcon';
import H1 from 'components/H1';
import H3 from 'components/H3';
import Icon from 'components/Icon';
import MessageModal from 'components/Modal/MessageModal';
import PageContent from 'components/PageContent';

class Agency extends React.Component {
    componentWillMount() {
        document.body.classList.add('profile-page');
        document.body.classList.add('agency-page');

        this.props.getCompanyById(this.props.params.id)
            .catch((err) => {
                this.props.changeLocation('/404');
            });
    }

    componentWillUnmount() {
        document.body.classList.remove('profile-page');
        document.body.classList.remove('agency-page');
    }

    render() {
        let { company } = this.props.accounts;

        return (
            <PageContent className="profile freelancer">
                <section className="profile__column profile__column--left">
                    <Avatar imageUrl={company.profilePicUrl} size="large" />

                    <header className="profile__header">
                        <H1 className="profile__name">
                            {company.name}
                        </H1>

                        <div className="profile__details">
                            <div className="profile__location">
                                <Icon type="location" />
                                {company.location != null ? company.location.name : ''}
                            </div>
                        </div>
                    </header>

                    <div className="profile__actions">
                        <Button className="profile__action"
                                noStyles
                                onClick={() => this.messageModal.showMessageModal()}>
                            <CircleIcon type="email"/>
                            Message {company.name}
                        </Button>

                        {/*<Button className="profile__action"
                                noStyles
                                onClick={() => alert('Favorite this agency')}>
                            <CircleIcon type="heart" />
                            Favorite
                        </Button>*/}
                    </div>

                    <div className="profile__contact">
                        {company.website != null ? (
                            <div>
                                <A href={`https://${company.website}`}>{company.website}</A>
                            </div>
                        ) : null}
                        {company.phoneNumber != null ? (
                            <div>
                                {company.phoneNumber}
                            </div>
                        ) : null}
                        <div>
                            <A href={`mailto:${company.email}`}
                               target="_blank">
                                {company.email}
                            </A>
                        </div>
                        {company.streetAddress != null && company.city != null && company.state != null ? (
                            <div>
                                <A href={`https://www.google.com/maps/place/${company.streetAddress.replace(' ' ,'+')}+${company.city.replace(' ' ,'+')}${company.state}${company.zip != null ? '+' + company.zip : ''}`}>Get Directions</A>
                            </div>
                        ) : null}
                    </div>
                </section>

                <section className="profile__column profile__column--right">
                    <header className="profile__header">
                        <H1 className="profile__name">
                            {company.name}
                        </H1>

                        <div className="profile__details">
                            <div className="profile__location">
                                <Icon type="location" />
                                {company.location != null ? company.location.name : ''}
                            </div>
                        </div>
                    </header>

                    <div className="profile__bio">
                        {company.description != null ? (
                            <div className="profile__about profile__bio-section">
                                <H3 className="profile__subtitle">
                                    About Us
                                </H3>
                                <div className="profile__about-text">
                                    {company.description.split(/\n/).map((paragraph) => {
                                        if(paragraph) {
                                            return <p>{paragraph}</p>;
                                        } else {
                                            return null;
                                        }
                                    })}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </section>

                <MessageModal
                    onRef={ref => (this.messageModal = ref)}
                />
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts,
        auth: state.auth,
        messaging: state.messaging
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearMessage: () => dispatch(clearMessage()),
        getCompanyById: (companyId) => dispatch(getCompanyById(companyId)),
        setMessage: (message) => dispatch(setMessage(message))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Agency);



// WEBPACK FOOTER //
// ./src/containers/Accounts/Profile/Agency/index.js